import { Navigate, useParams } from 'react-router-dom';
import { useGetGroupProovedores } from "@/shared/actions/erp";
import { LoaderComponent } from '@/shared/components/ui';
import { SaveProveedor } from "../../shared/components/saveGroupProveedores";

export interface UpdateProveedorPageInterface {}

const UpdateGroupProveedorPage: React.FC<UpdateProveedorPageInterface> = () => {
    const { id } = useParams();
    const { data, isLoading } = useGetGroupProovedores(+id!);
    
    if (isLoading) return <LoaderComponent />;
    if (!data?.data?.id_grupo_proveedor) return <Navigate to="/compras/grupo-proveedores" />;
    
    return <SaveProveedor titlePage="Editar Proveedor" editProveedor={data.data} />;
}

export default UpdateGroupProveedorPage;